import React from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'

import styles from './style.module.scss'
import { BLUR_DATA_URL_BASE64, S3_PREFIX } from '@shared-submodule/sm-constants'
import teamImg from '@assets/images/placeholder/team-placeholder.svg'
import { calculateAge, getPlayerRole } from '@shared-submodule/utils'

const MyImage = dynamic(() => import('@shared/components/myImage'))
const BreadcrumbNav = dynamic(() => import('@shared/components/breadcrumbNav'))

const TeamHeader = ({ data }) => {
  return (
    <>
      <BreadcrumbNav dynamicName={data?.sTitle}/>
      <section className={`${styles.teamHeader} d-flex align-items-start mb-md-3 mt-3`}>
        <div className={`${styles.teamPic} overflow-hidden rounded-circle`}>
          <MyImage
            src={data?.oImg?.sUrl ? `${S3_PREFIX}${data?.oImg?.sUrl}` : teamImg}
            alt="user"
            blurDataURL={BLUR_DATA_URL_BASE64}
            placeholder="blur"
            layout="responsive"
            width="40"
            height="40"
            errorImage={teamImg}
          />
        </div>
        <div className={`${styles.content} flex-grow-1`}>
          <h1 className="mb-1 mt-3 mb-xl-0">{data?.sTitle}</h1>
          <div className={`${styles.info} d-flex justify-content-between flex-column flex-xl-row align-items-xl-center`}>
            <div className={`${styles.perInfo} d-flex align-items-center big-text flex-wrap flex-sm-nowrap`}>
              {data?.dBirthDate && (
                <p className="mb-0 d-flex align-items-center">
                  {data?.dBirthDate ? `${calculateAge(data?.dBirthDate)} Years` || '-' : '-'}
                </p>
              )}
              {data?.sBattingStyle && (
                <p className={`${styles.pType} mb-2 mb-sm-0 d-flex align-items-center`}>{data?.sBattingStyle?.replaceAll('_', ' ')}</p>
              )}
            </div>
          </div>
        </div>
      </section>
      <div className={'d-flex gap-2 justify-content-xl-start flex-wrap'} style={{ width: '100%' }}>
          {data?.aRanking?.map((rank, i) => (
            <div
              key={`#${rank.nRank}-${rank?.eRankType || getPlayerRole(data.sPlayingRole)}-in-${rank.eMatchType}-${i}`}
              className={`${styles.ranks} mt-xl-0`}>
              <div className={styles.btn}>
                {`# ${rank.nRank} ${rank?.eRankType || getPlayerRole(data.sPlayingRole)} in ${rank.eMatchType}`}
              </div>
            </div>
          ))}
        </div>
    </>
  )
}

TeamHeader.propTypes = {
  data: PropTypes.object
}

export default TeamHeader
